if (!customElements.get("quantity-tiers")) {
  class QuantityTiers extends HTMLElement {
    connectedCallback() {
      this.section = this.closest(".js-product") || document;
      this.tiers = Array.from(this.querySelectorAll(".quantity-tiers__tier"));
      this.savings = JSON.parse(
        this.querySelector('script[type="application/json"]').textContent,
      );
      // Custom: savings incl. the discount code (only present if it applies).
      const codeSavingsEl = this.querySelector("script[data-code-savings]");
      this.codeSavings = codeSavingsEl
        ? JSON.parse(codeSavingsEl.textContent)
        : {};

      this.handleQuantityUpdate = this.handleQuantityUpdate.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);

      this.addEventListener("click", this.handleClick.bind(this));
      this.section.addEventListener(
        "quantity-updated",
        this.handleQuantityUpdate,
      );
      this.section.addEventListener(
        "on:variant:change",
        this.handleVariantChange,
      );

      const input = this.getQuantityInput();
      if (input) this.updateActiveTier(input.value);
    }

    disconnectedCallback() {
      this.section.removeEventListener(
        "quantity-updated",
        this.handleQuantityUpdate,
      );
      this.section.removeEventListener(
        "on:variant:change",
        this.handleVariantChange,
      );
    }

    /**
     * Gets the quantity input of the product form.
     * @returns {?Element}
     */
    getQuantityInput() {
      return this.section.querySelector('.qty-input__input[name="quantity"]');
    }

    /**
     * Handles 'click' events on the tiers by setting the tier's amount in the quantity input.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      const tier = evt.target.closest(".quantity-tiers__tier");
      const input = this.getQuantityInput();
      if (!tier || !input) return;

      input.value = tier.dataset.quantity;
      // The quantity-input element emits 'quantity-updated' in response to the 'input' event.
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
      this.updateActiveTier(input.value);
    }

    /**
     * Handles 'quantity-updated' events of the quantity input.
     * @param {object} evt - Event object.
     */
    handleQuantityUpdate(evt) {
      this.updateActiveTier(evt.detail.quantity);
    }

    /**
     * Handles 'on:variant:change' events of the variant picker.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const savings = evt.detail.variant && this.savings[evt.detail.variant.id];
      if (!savings) return;

      const codeSavings = this.codeSavings[evt.detail.variant.id];

      this.tiers.forEach((tier, i) => {
        tier.querySelector(".quantity-tiers__saving-amount").innerHTML =
          savings[i];

        const codeSavingEl = tier.querySelector(
          ".quantity-tiers__code-saving-amount",
        );
        if (codeSavingEl && codeSavings) codeSavingEl.innerHTML = codeSavings[i];
      });
    }

    /**
     * Highlights the tier that applies to the given quantity.
     * @param {number|string} quantity - Selected quantity.
     */
    updateActiveTier(quantity) {
      const qty = parseInt(quantity, 10) || 0;
      const activeTier = this.tiers
        .filter((tier) => qty >= Number(tier.dataset.quantity))
        .pop();

      this.tiers.forEach((tier) => {
        tier.setAttribute("aria-pressed", tier === activeTier);
      });
    }
  }

  customElements.define("quantity-tiers", QuantityTiers);
}
